import { from, Observable, of } from 'rxjs';
import { ofType } from 'redux-observable';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { Verify, VerifyAction, VerifyActions, VerifyError, VerifySuccess } from '../actions/verify.action';
import VerifyService from '../services/verify.service';
import { CreateErrorNotice } from '../../store/actions/toaster.action';
import { LoginRequest, LoginSuccess } from '../actions';
import AuthUtils from '../../shared/utils/auth-utils';
import { LoadUserProfileInfo } from '../../profile/actions/profile.action';

const verifyEpic = (action$: Observable<VerifyAction>) => action$.pipe(
  ofType<Verify>(VerifyActions.Verify),
  switchMap((action) => from(VerifyService.verify(action.apiOptions)).pipe(
    mergeMap((response) => of(
      new VerifySuccess(response),
      new LoadUserProfileInfo({
        event: 'registrationComplete',
        isLoadAfterLogin: action.isRegistrationComplete
      }),

    )),
    catchError(() => of(
      new VerifyError('Your registration link has expired. The link expires after 4 hours and cannot be resent. Please re-register your account.')
    ))
  )),
);

const verifySuccessEpic = (action$: Observable<VerifyAction>) => action$.pipe(
  ofType<VerifySuccess>(VerifyActions.VerifySuccess),
  mergeMap(() => of(
    new LoginSuccess({
      authed: true,
      sessionToken: AuthUtils.getAccessToken(),
      sessionTokenExpiration: new Date(AuthUtils.getAccessTokenExp()),
      errorText: '',
    }),
    new LoginRequest({
      token: AuthUtils.getAccessToken()
    })
  )),
);

const verifyErrorEpic = (action$: Observable<VerifyAction>) => action$.pipe(
  ofType<VerifyError>(VerifyActions.VerifyError),
  map(() => new CreateErrorNotice('Error', 'Your verification code was invalid.'))
);

const VerifyEpics = [
  verifyEpic,
  verifySuccessEpic,
  verifyErrorEpic,
];

export default VerifyEpics;
